import { render, staticRenderFns } from "./ManageAppointment.vue?vue&type=template&id=6b9250b1&"
import script from "./ManageAppointment.vue?vue&type=script&lang=js&"
export * from "./ManageAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports